module.exports = __webpack_public_path__ + "media/images/athletes/1846-d5b97dd24266fdecf6ce1a54f533d65a.png";